import { MdOutlineHistory, MdAccountBalanceWallet } from "react-icons/md";
import { FiSend } from "react-icons/fi";
import { HiOutlineUsers } from "react-icons/hi";
import { RiUserSettingsLine } from "react-icons/ri";
import { FaUserPlus } from "react-icons/fa";

import BusinessOverviewDashboard from '../../business/dashboard/BusinessOverviewDashboard';
import TransactionDashboard from '../../business/transactions/TransactionDashboard';
import TransactionDetails from '../../business/transactions/transactionDetails/TransactionDetails';
import TransferRegistration from '../../business/transfers/TransferRegistration';
import Agents from '../../business/agents/Agents';
import Balances from '../../business/balances/CountryBalance';
import BalanceRegistrationForm from '../../business/balances/BalanceRegistrationForm';
import BusinessAddUserPage from '../../business/users/userRegistration/BusinessAddUserPage';
import TeamPage from '../../business/team/TeamPage';
import UserDetailsPage from '../../business/team/UserDetailsPage';
import AgentDetails from '../../business/agents/AgentDetails';
import InvitationsPage from '../../business/invitations/InvitationsPage';
import Customers from '../../business/customer/Cusromers';
import CustomerDetails from '../../business/customer/CustomerDetails';
import SettingsPage from '../settings/Settings';

import {
  MdSpaceDashboard,
  MdPersonAddAlt1,
  MdBusiness,
  MdPeopleOutline,
  MdAssignment,
  MdSettings,
  MdMarkEmailUnread,
} from "react-icons/md";

import { lazy } from "react";
import AuditLogDetails from "../../management/audit/AuditLogDetails";
const AdminDashboard = lazy(() => import("../../management/dashboard/AdminDashboard"));
const RequestsList = lazy(() => import("../../management/onboarding/RequestsList"));
const BusinessList = lazy(() => import("../../management/businesses/BusinessList"));
const BusinessDetails = lazy(() => import("../../management/businesses/BusinessDetails"));
const UserList = lazy(() => import("../../management/users/UserList"));
const UserDetails = lazy(() => import("../../management/users/UserDetails"));
const AuditLog = lazy(() => import("../../management/audit/AuditLog"));
const SystemSettings = lazy(() => import("../../management/settings/SystemSettings"));

/* =========================
   BUSINESS APP ROUTES (existing)
   ========================= */
export const appRoutes = [
  {
    key: 'overview',
    path: '',
    label: 'Overview',
    icon: MdSpaceDashboard,
    element: <BusinessOverviewDashboard />,
    showInSidebar: true,
    end: true,
  },
  {
    key: 'transactions',
    path: 'transactions',
    label: 'Transactions',
    icon: MdOutlineHistory,
    element: <TransactionDashboard />,
    showInSidebar: true,
  },
  {
    key: 'transfer',
    path: 'transfer',
    label: 'Transfer',
    icon: FiSend,
    adminOnly: true,
    element: <TransferRegistration />,
    showInSidebar: true,
  },
  {
    key: 'transfer-new',
    path: 'transfer/new',
    label: 'Transfer',
    icon: FiSend,
    adminOnly: true,
    element: <TransferRegistration />,
    showInSidebar: false,
  },
  {
    key: 'customers',
    path: 'customers',
    label: 'Customers',
    icon: HiOutlineUsers,
    element: <Customers />,
    showInSidebar: true,
  },
  {
    key: 'agents',
    path: 'agents',
    label: 'Agents',
    icon: RiUserSettingsLine,
    adminOnly: true,
    element: <Agents />,
    showInSidebar: true,
  },
  {
    key: 'team',
    path: 'team',
    label: 'Team',
    icon: MdPeopleOutline,
    adminOnly: true,
    element: <TeamPage />,
    showInSidebar: true,
  },
  {
    key: 'invitations',
    path: 'invitations',
    label: 'Invitations',
    icon: MdMarkEmailUnread,
    adminOnly: true,
    element: <InvitationsPage />,
    showInSidebar: true,
  },
  {
    key: 'balance',
    path: 'balance',
    label: 'Country Balances',
    icon: MdAccountBalanceWallet,
    element: <Balances />,
    showInSidebar: true,
  },
  {
    key: 'create-user',
    path: 'create-user',
    label: 'Add new user',
    icon: FaUserPlus,
    adminOnly: true,
    element: <BusinessAddUserPage />,
    showInSidebar: false,
  },

  // detail / utility routes (no sidebar)
  {
    key: 'transaction-details',
    path: 'transaction/:id',
    label: 'Transaction Details',
    element: <TransactionDetails />,
    showInSidebar: false,
  },
  {
    key: 'agent-details',
    path: 'agent/:agentUuid',
    label: 'Agent Details',
    element: <AgentDetails />,
    showInSidebar: false,
  },
  {
    key: 'team-user-details',
    path: 'team/:userUuid',
    label: 'Team Member',
    adminOnly: true,
    element: <UserDetailsPage />,
    showInSidebar: false,
  },
  {
    key: 'customer-details',
    path: 'customers/:uuid',
    label: 'Customer Details',
    element: <CustomerDetails />,
    showInSidebar: false,
  },
  {
    key: 'add-balance',
    path: 'add-balance',
    label: 'Add Balance',
    adminOnly: true,
    element: <BalanceRegistrationForm />,
    showInSidebar: false,
  },
  {
    key: 'settings',
    path: 'settings',
    label: 'Settings',
    element: <SettingsPage />,
    showInSidebar: false,
  },
];

export const sidebarTabs = (isAdmin) =>
  appRoutes.filter(r => r.showInSidebar && (!r.adminOnly || isAdmin));

export const findRouteByPathname = (pathname) => {
  const normalizedPath = pathname.replace(/\/+$/, "") || "/";
  const parts = normalizedPath.split("/").filter(Boolean);
  let slug = parts[parts.length - 1] || "";

  if (normalizedPath === "/home" || (parts[0] === "home" && parts.length === 1)) {
    slug = "";
  }

  if (pathname.includes('/transaction/')) return appRoutes.find(r => r.key === 'transaction-details');
  if (pathname.includes('/agent/')) return appRoutes.find(r => r.key === 'agent-details');
  if (pathname.includes('/team/')) return appRoutes.find(r => r.key === 'team-user-details');
  if (pathname.includes('/customers/') && slug !== 'customers') return appRoutes.find(r => r.key === 'customer-details');

  return appRoutes.find(r => r.path === slug) || null;
};

export const adminRoutes = [
  {
    key: 'admin-dashboard',
    path: '', 
    label: 'Dashboard',
    icon: MdSpaceDashboard,
    element: <AdminDashboard />,
    showInSidebar: true,
    end: true,
  },
  {
    key: 'admin-onboarding',
    path: 'onboarding',
    label: 'Onboarding',
    icon: MdPersonAddAlt1,
    element: <RequestsList />,
    showInSidebar: true,
  },
  {
    key: 'admin-businesses',
    path: 'businesses',
    label: 'Businesses',
    icon: MdBusiness,
    element: <BusinessList />,
    showInSidebar: true,
  },
  {
    key: 'admin-business-details',
    path: 'businesses/:uuid',
    label: 'Business Details',
    element: <BusinessDetails />,
    showInSidebar: false,
  },
  {
    key: 'admin-users',
    path: 'users',
    label: 'Users',
    icon: MdPeopleOutline,
    element: <UserList />,
    showInSidebar: true,
  },
  {
    key: 'admin-user-details',
    path: 'users/:userId',
    label: 'User Details',
    element: <UserDetails />,
    showInSidebar: false,
  },
  {
    key: 'admin-audit',
    path: 'audit',
    label: 'Audit Log',
    icon: MdAssignment,
    element: <AuditLog />,
    showInSidebar: true,
  },
  {
    key: 'admin-audit-details',
    path: 'audit/:auditId',
    label: 'Audit Log Details',
    icon: MdAssignment,
    element: <AuditLogDetails />,
    showInSidebar: false,
  },
  {
    key: 'admin-settings',
    path: 'settings',
    label: 'Settings',
    icon: MdSettings,
    element: <SystemSettings />,
    showInSidebar: true,
  },
];

export const adminSidebarTabs = () =>
  adminRoutes.filter(r => r.showInSidebar);

export const findAdminRouteByPathname = (pathname) => {
  const tail = pathname.replace(/^\/admin\/?/, "");
  if (tail === "" || tail === "/") return adminRoutes.find(r => r.key === "admin-dashboard");

  const staticMatch = tail.split("/")[0];
  return (
    adminRoutes.find(r => r.path === staticMatch) ||
    adminRoutes.find(r => r.path?.startsWith(staticMatch + "/")) ||
    null
  );
};
